import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsDescriptionStyles {
    wrapper?: InjectableCss;
    attrText?: TypographyPresentationProps;
    detailDesc?: InjectableCss;
}

export const descriptionStyles: ProductDetailsDescriptionStyles = {
    wrapper: {
        css: css`
            margin-bottom: 15px;
        `,
    },
    attrText: {
        css: css`
            padding: 10px;
            width: fit-content;
            border: 1px solid ${getColor("common.border")};
            border-bottom: none;
            position: relative;
            top: 0.7px;
            background: #fff;
            margin-bottom: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-left: 15px;
                        padding-right: 15px;
                    `,
                    css`
                        padding-left: 15px;
                        padding-right: 15px;
                    `,
                    css`
                        padding-left: 15px;
                        padding-right: 15px;
                    `,
                    css`
                        padding-left: 30px;
                        padding-right: 30px;
                    `,
                    css`
                        padding-left: 30px;
                        padding-right: 30px;
                    `,
                ])}
        `,
    },
    detailDesc: {
        css: css`
            border: 1px solid ${getColor("common.border")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 10px;
                    `,
                    css`
                        padding: 10px;
                    `,
                    css`
                        padding: 10px;
                    `,
                    css`
                        padding: 25px;
                    `,
                    css`
                        padding: 25px;
                    `,
                ])}
        `,
    },
};

const styles = descriptionStyles;

const ProductDetailsDescription: React.FC<Props> = ({ product }) => {
    if (!product.content) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.attrText} variant="h3" as="span">
                {translate("Description")}
            </Typography>
            <StyledWrapper {...styles.detailDesc}>
                <div data-test-selector="productDetails_htmlContent">
                    {parse(transformContentHtml(product.content.htmlContent), parserOptions)}
                </div>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsDescription),
    definition: {
        displayName: "Description",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
